import React, { useEffect } from 'react';
import OAuth2Service from 'app/services/OAuth2.service';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setIsLoading } from 'app/reducers/appInitSlice';

const OAuth2LoadingPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    if (code) {
      dispatch(setIsLoading(true))
      OAuth2Service.getOAuthToken().then((accessToken) => {
        localStorage.setItem('token', accessToken)
        OAuth2Service.periodicalCheckForTokenValidity(accessToken, (newToken) => localStorage.setItem('token', newToken));
      }).finally(() => {
        dispatch(setIsLoading(false))
        history.push('/'); // should trigger login process again if fetch token fails
      })
    }
  }, []);
  return (
    <div>
    </div>
  );
}

export default OAuth2LoadingPage;
